import React from 'react'
import { discount1, discount2, discount3, hero1, hero2, hero3, hero4, heroBg, logo } from '../../../assets/images';
import { useTranslation } from 'react-i18next';


const SubOtherHeroCareersDetail = ({ title, content, detail }) => {

  const { t, i18n } = useTranslation();
  return (
     <div className="md:max-w-container max-w-containerSm mx-auto flex justify-between md:h-[733px] pb-[20px] md:pb-[45px] ">
      <div className="w-full pt-[36px] md:pt-[77px] text-white">
        <p className='text-[24px] md:text-[32px] font-medium text-center'>{content}</p>
     <div className='text-[14px] md:text-[16px] flex items-center justify-center mt-[4px]'>
  <p>Ana səhifə</p>
  <i className={`fas fa-chevron-right mx-2`} /> 
  <p>{title}</p>
  <i className={`fas fa-chevron-right mx-2`} /> 
  <p>{content}</p>
  <i className={`fas fa-chevron-right mx-2`} /> 
  <p>{detail}</p>
</div>

        </div> 
    
  </div>
  )
} 

export default SubOtherHeroCareersDetail 